import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { EnvironmentVariablesService } from '../../../core/services/environment-variable-service/environment-variables.service';
import { RecaptchaValidationService } from '../../services/recatpcha-validation/recaptcha-validation.service';
import { ExposedEnvironmentVariable } from '../../../../environments/environment-variables';
import { VerifyRecaptchaCodeRequestDto } from '../../interfaces/recaptcha-validation.interfaces';

@Component({
  selector: 'ose-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss'],
})
export class RecaptchaComponent implements OnInit {
  @Input() captchaFormControl!: AbstractControl;

  recaptchaKey: string;

  get captchaFormControlAsFormControl(): FormControl {
    return this.captchaFormControl as FormControl;
  }

  constructor(
    private environmentVariablesService: EnvironmentVariablesService,
    private recaptchaValidationService: RecaptchaValidationService
  ) {}

  ngOnInit(): void {
    this.recaptchaKey = this.environmentVariablesService.getVar(ExposedEnvironmentVariable.RECAPTCHA_KEY);
  }

  verifyRecaptchaCode(token: string): void {
    if (!token) {
      return;
    }
    this.captchaFormControl.setErrors(null);
    const request: VerifyRecaptchaCodeRequestDto = {
      token,
      siteKey: this.environmentVariablesService.getVar(ExposedEnvironmentVariable.RECAPTCHA_KEY),
    };
    this.recaptchaValidationService.verifyCaptcha(request).subscribe(
      (response) => {
        if (!response) {
          this.handleReCaptchaError();
        }
      },
      () => {
        this.handleReCaptchaError();
      }
    );
  }

  private handleReCaptchaError() {
    this.captchaFormControl.setValue(null);
    this.captchaFormControl.setErrors({ isRiskScoreInvalid: { valid: false } });
  }
}
